import React from "react";
import "./connections.css";

const invites = [
  {
    id: 1,
    name: "Amazon Shopping",
    logo: "https://upload.wikimedia.org/wikipedia/commons/d/de/Amazon_icon.png",
    points: 750,
  },
  {
    id: 2,
    name: "Apple TV+",
    logo: "https://upload.wikimedia.org/wikipedia/commons/2/28/Apple_TV_Plus_Logo.svg",
    points: 750,
  },
  {
    id: 3,
    name: "Myntra Shopping",
    logo: "https://upload.wikimedia.org/wikipedia/commons/b/bc/Myntra_Logo.png",
    points: 750,
  },
  {
    id: 4,
    name: "iTunes",
    logo: "https://upload.wikimedia.org/wikipedia/commons/f/fa/Apple_logo_black.svg",
    points: 750,
  },
];

const MyInvites = () => {
  return (
    <div className="invites-container">
      <h2 className="invites-title">My Invites</h2>
      {invites.map((invite) => (
        <div className="invite-card" key={invite.id}>
          <div className="invite-left">
            <img src={invite.logo} alt={invite.name} className="invite-logo" />
            <div>
              <h3 className="invite-name">{invite.name} <span className="star">*</span></h3>
              <p className="invite-desc">
                You're invited to connect your account to Torfacts.
              </p>
            </div>
          </div>

          <div className="invite-right">
            <div className="invite-points">
              <span className="points-icon"></span> +{invite.points} points
            </div>
            <button className="connect-btn">+ Connect  </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MyInvites;
